import { render, staticRenderFns } from "./ResultGame.vue?vue&type=template&id=f84c655a"
import script from "./ResultGame.vue?vue&type=script&lang=js"
export * from "./ResultGame.vue?vue&type=script&lang=js"
import style0 from "./ResultGame.vue?vue&type=style&index=0&id=f84c655a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports